/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysqueAlertComponent } from './sysque-alert.component';

@NgModule({
  declarations: [SysqueAlertComponent],
  imports: [CommonModule],
  exports: [SysqueAlertComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueAlertModule {}
